import React from 'react';
import { FormProps } from './types';

function isReadOnly(type: string) {
  return (type === 'user' || type === 'weather' || type === 'now');
}

function ReadOnlyText({
  name, question, onChange, value,
}: FormProps, ref) {
  if (!isReadOnly(question.type)) return null;

  return (
    <>
      <div className="dynamic-form-label">{question.label}</div>
      <div className="dynamic-form-input">
        <input
          type="text"
          ref={ref}
          name={name}
          onChange={onChange}
          readOnly
          value={value}
        />
      </div>
    </>
  );
}

export default React.forwardRef(ReadOnlyText);
